import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthLocalStorage } from '../../modules/useLocalStore';
import style from './profile.module.css'
import nopic from '../../img/no_photo_neutral.svg'

import camera from '../../img/camera.svg'
import back_ph from '../../img/back_ph.svg'
import next_ph from '../../img/next_ph.svg'
import gift from '../../img/gift.svg'
import bottom_open from '../../img/bottom.svg'

function Profile({myProfile,setMyProfile}){

    const { getToken } = useAuthLocalStorage();
    
    const token = getToken();

    const [mobileOpen,SetMobileOpen] = useState(false);
    const toggleCard = () => {
        SetMobileOpen(prevState => {
            return !prevState ;
        });
    };
    const [profile,SetProfileDate] = useState();

    useEffect(() => {
        if(myProfile.info.profile === null)
        {
            SetProfileDate({
                userid: myProfile.userid,
                photo: myProfile.photo,
                name: myProfile.name,
                day: myProfile.day,
                month: myProfile.month,
                year: myProfile.year,
                text: myProfile.text,
                target: myProfile.target,
                hobby: myProfile.hobby,
                city: myProfile.city,
                activeph: 0
            });
        }
        else
        {
            PopupOpen(21);
            const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getAccount`;
            const config = {
                headers: {
                Authorization: "Bearer " + token
                }
            };
            axios.post(url,{id: myProfile.info.profile}, config)
                .then(response => {
                    
                    if(!response.data.error)
                    {
                        const prof = response.data;
                        const text = prof.disc ?? '';
                        let hobby;
                        if (prof.hobby !== null) {
                        hobby = prof.hobby.split(',');
                        } else {
                        hobby = [];
                        }
                        let city;
                        if(prof.fake > 0) city = myProfile.city;
                        else city = prof.city;
                        SetProfileDate({
                            userid: prof.id,
                            photo: prof.photo,
                            name: prof.name,
                            day: prof.day,
                            month: prof.month,
                            year: prof.year,
                            city: city,
                            target: prof.target,
                            text: text,
                            hobby: hobby,
                            activeph: 0
                        });
                        exitPopup();
                    }
                })
                    .catch(error => {
                        exitPopup();
                    
                        
                });
        }
    }, [myProfile.info.profile]);
    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    const exitPopup = () => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: null
            }
        }));
    }
    const SendMessage = (id) => {
        if(myProfile.money <= 0) return PopupOpen(8);
        setMyProfile(prevState => ({
            ...prevState,
            sendselect: id
        }));
        PopupOpen(11);
    };
    const getAge = (day, month, year) => {
        const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

        const birthDate = new Date(`${months.indexOf(month) + 1}/${day}/${year}`);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
    
            const absYears = Math.abs(age) % 100; // Берем абсолютное значение и остаток от деления на 100
            const lastDigit = absYears % 10; // Берем остаток от деления на 10
        
            if (absYears > 10 && absYears < 20) {
                return `${age} лет`;
            }
        
            if (lastDigit === 1) {
                return `${age} год`;
            }
        
            if (lastDigit >= 2 && lastDigit <= 4) {
                return `${age} года`;
            }
        
            return `${age} лет`;
    };
    const NextPh = () => {
        if(profile.photo[profile.activeph+1])
        {
            SetProfileDate(prevState => {
                return { ...prevState, activeph: profile.activeph+1 };
            });
        }
        else
        {
            SetProfileDate(prevState => {
                return { ...prevState, activeph: 0 };
            });
        }
    };
    const BackPh = () => {
        if(profile.photo[profile.activeph-1])
        {
            SetProfileDate(prevState => {
                return { ...prevState, activeph: profile.activeph-1 };
            });
        }
        else
        {
            SetProfileDate(prevState => {
                return { ...prevState, activeph: profile.photo.length-1 };
            });
        }
    };
    const SendPresent = (id) => {
        setMyProfile(prevState => ({
            ...prevState,
            sendselect: id
        }));
        PopupOpen(9);
    };
    return(
        (profile && profile.userid ?
        <div className={style.flexblock}>
            <div className={style.rightblock}>
                <div className={style.card}>
                    <div className={style.cardleft} style={{ backgroundImage: `url(${profile.photo[profile.activeph] ? `https://winxy.ru/static_img.php?id=${profile.photo[profile.activeph].id}` : nopic})`}}>
                        <div className={style.topcard}>
                            <div className={style.countph}>
                                 <img src={camera} alt=''/>
                                 <p>{profile && profile.photo && profile.photo.length > 0 ? profile.activeph+1+'/'+profile.photo.length : '1/1' }</p>
                            </div>
                        </div>
                        <div className={style.centercard}>
                            <div className={style.backph} onClick={BackPh}>
                                <img src={back_ph} alt=''/>
                            </div>
                            <div className={style.nextph} onClick={NextPh}>
                                <img src={next_ph} alt=''/>
                            </div>
                        </div>
                        <div className={style.bottomcard}>
                        {myProfile.info.profile !== null ? 
                            <div className={style.btnmin} onClick={ () => SendPresent(profile.userid)}>
                                <img src={gift} alt=''/>
                            </div>
                        : null }
                        </div>
                    </div>
                    <div className={style.rightcard + ' ' + (mobileOpen ? style.opened : null)}>
                        <div className={style.flexopenmob}>
                            <h3>{profile.name} {getAge(profile.day, profile.month, profile.year)}</h3>
                            <img src={bottom_open} onClick={toggleCard} alt=''/>
                        </div>
                        <div className={style.hidemobile}>
                            <div className={style.scroll}>
                                <div className={style.flexhobby}>
                                    {profile.hobby ?
                                    profile.hobby.map((hb,index) =>
                                        <div key={index} className={style.hobby}>
                                            {hb}
                                        </div>

                                    ):null}
                                    
                                </div>
                            </div>
                            <h4>Город:</h4>
                            <p>{profile.city}</p>
                            <h4>Цель знакомства:</h4>
                            <p>{profile.target}</p>
                            <h4>О себе:</h4>
                            <p>{profile.text}</p>
                            {myProfile.info.profile !== null ? 
                            <button className={style.btnsend} onClick={ () => SendMessage(profile.userid)}>Написать</button>
                            : null }
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        :null)
     );
}

export default Profile;